import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const adminsApi = createApi({
  reducerPath: "adminsApi",
  baseQuery: customFetchBase({ url: "admins/" }),
  endpoints: (builder) => ({
    usernamePassLogin: builder.mutation({
      query: ({ username, password }) => ({
        url: "auth/login/pass",
        method: "POST",
        body: { username, password },
      }),
    }),
    logoutAdmin: builder.mutation({
      query: () => ({
        url: "auth/logout",
        method: "DELETE",
      }),
    }),
  }),
});
export const { useUsernamePassLoginMutation, useLogoutAdminMutation } =
  adminsApi;
